import clsx from "clsx";
import { memo } from "react";

import type { IIconCoreProps } from "@icon/type";

function toKebabCase(name: string) {
  return name
    .replaceAll(/([a-z\d])([A-Z])/g, "$1-$2")
    .replaceAll(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
    .replaceAll(/([a-zA-Z])(\d)|(\d)([a-zA-Z])/g, "$1$3-$2$4")
    .toLowerCase();
}

export const IconCore = memo(function Icon({
  iconName,
  size = 20,
  color,
  className,
  style,
}: IIconCoreProps) {
  const iconClass = `ri-${toKebabCase(iconName)}`;

  return (
    <i
      className={clsx(iconClass, className)}
      style={{
        fontSize: size,
        color,
        lineHeight: 1,
        display: "inline-flex",
        ...style,
        fontWeight: "normal",
      }}
      aria-hidden
    />
  );
});
